// Valores que antes entregaba ConfProyecto (utilitarios-base), ya fuera del proyecto.
export class AppResource {
  static readonly nombreAplicacion = 'MiApp';
  static readonly pathSession = '/auth/session';
}
